import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import InputMask from "react-input-mask";
import { styled } from "@mui/material/styles";
import { useField } from "formik";

const CssTextField = styled(TextField)(({ theme }) => ({
  "& label.Mui-focused": {
    color: "#0060aa",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#0060aa",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? "rgb(204 204 204 / 45%)" : "#e5e5e5",
    },
    "&:hover fieldset": {
      borderColor: "#0060aa",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0060aa",
    },
  },
}));

const NumberRangeInput = ({
  name_start,
  name_end,
  handleChange,
  ...otherProps
}: any) => {
  const [field, meta] = useField(name_start);
  const [fieldEnd, metaEnd] = useField(name_end);
  const configTextfield = {
    ...field,
    ...otherProps,
    fullWidth: true,
    //variant: "outlined",
    error: false,
    helperText: "",
    value: field.value,
    onChange: handleChange,
  };

  const configTextfieldEnd = {
    ...fieldEnd,
    ...otherProps,
    fullWidth: true,
    //variant: "outlined",
    error: false,
    helperText: "",
    value: fieldEnd.value,
    onChange: handleChange,
  };

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }
  if (metaEnd && metaEnd.touched && metaEnd.error) {
    configTextfieldEnd.error = true;
    configTextfieldEnd.helperText = metaEnd.error;
  }

  return (
    <>
      <Grid container alignItems="center">
        <Grid item md={5}>
          <InputMask
            mask="(999)-999-99-99"
            name={name_start}
            {...configTextfield}
          >
            {(inputProps: any) => (
              <CssTextField
                name={name_start}
                {...inputProps}
                {...configTextfield}
                type="tel"
              />
            )}
          </InputMask>
        </Grid>
        <Grid item md={2}>
          <Typography sx={{ textAlign: "center" }}>-</Typography>
        </Grid>
        <Grid item md={5}>
          <InputMask
            mask="(999)-999-99-99"
            name={name_end}
            {...configTextfieldEnd}
          >
            {(inputProps: any) => (
              <CssTextField
                name={name_end}
                {...inputProps}
                {...configTextfieldEnd}
                type="tel"
              />
            )}
          </InputMask>
        </Grid>
      </Grid>
    </>
  );
};

export default NumberRangeInput;
